





























import { Component, Prop, Vue } from 'vue-property-decorator';
import {ToggleButton} from 'vue-js-toggle-button'
import {Purpose} from '@iabtcf/core/lib/model/gvl'
import {TCModel} from '@iabtcf/core/lib/TCModel';


@Component({
  components: {
    ToggleButton,
  },
})

export default class SpecialPurposeItem extends Vue {

    consent = false;
    legitInterest = false;

    collapsed = true;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    formattedDescriptions :string[] = [];
    formattedCanNotDescriptions :string[] = [];
    introDescription :string = "Our partners may:";

    @Prop( { default:{ name:'none', id:0 } }) purpose!: Purpose;

    mounted() : void {

      
      let parts = this.purpose.descriptionLegal.split("Vendors cannot:")

      if (parts.length) {
        let s = parts[0].replace("Vendors can:", "")
        s = s.replace(/(\r\n|\n|\r)/gm, "")
        s = s.replace("N.B. ", " ")

        this.formattedDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
        
        if ( this.formattedDescriptions.length ) {
          this.introDescription = <string> this.formattedDescriptions.shift(); // remove and return first element
        }

        if (parts.length > 1) {
          let s = parts[1].replace(/(\r\n|\n|\r)/gm, "");
          s = s.replace("N.B. ", " ");

          this.formattedCanNotDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
          }
      
      }
    }

    expandCollapseClick() {
      if ( this.collapsed )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';

      this.collapsed = ! this.collapsed;
    }

}

